var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJerry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 461.44 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-jerry-1,.cls-jerry-15{fill:none;}.cls-jerry-2{fill:#9a5934;}.cls-jerry-3{fill:#d7c5bb;}.cls-jerry-4{fill:#191616;}.cls-jerry-5{fill:#83472c;}.cls-jerry-6{clip-path:url(#clip-jerry-path-1);}.cls-jerry-7{clip-path:url(#clip-jerry-path-2);}.cls-jerry-10,.cls-jerry-8{fill:#381905;}.cls-jerry-9{fill:#4d241c;}.cls-jerry-10{opacity:0.4;}.cls-jerry-11{fill:#e9cdcd;}.cls-jerry-12{fill:#903823;}.cls-jerry-13{fill:#924032;}.cls-jerry-14{fill:#456043;}.cls-jerry-15{stroke:#edded2;stroke-miterlimit:10;stroke-width:1.08px;}.cls-jerry-16{fill:#0f0d0d;}.cls-jerry-17{fill:#edded2;}.cls-jerry-18{fill:#1e1b1a;}.cls-jerry-19{fill:#905130;}.cls-jerry-20{fill:#989492;}.cls-jerry-21{fill:#a7a4a2;}.cls-jerry-22{fill:#3a160b;}.cls-jerry-23{fill:#908682;}.cls-jerry-24{fill:#fff;}.cls-jerry-25{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-jerry-path-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-1",
    d: "M167.5,144.52s1.44,25.08-.65,41c0,0,10,35.19,36.1,37.54s67.93-47.48,67.93-47.48l-.94-20.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-jerry-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-2",
    d: "M166.77,74.94s-.85-40.37,14.66-56.41C193.58,6,221-4.15,244.47,1.7,273,8.8,300.35,35.14,289.19,77c0,0-3.88,9.62-4.08,18.41s-1.87,27.27-5.81,39.6-11.55,30-19.67,37-17.13,15.22-20.83,19.44-13.62,8.32-23.53,6.77A39.42,39.42,0,0,1,188.78,181c-6.75-9.93-8.43-16.27-14.08-23.2s-10.63-21.8-10.79-29.76c-.12-6-2.62-24.11.26-34.16C165.8,88.22,166.77,74.94,166.77,74.94Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-3",
    d: "M160.1,199.93s-26.61,175.44-5,232.66l79.66,15.63S267.55,233.32,271,214.56C271,214.56,190.93,230.13,160.1,199.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-4",
    d: "M49.46,229.77s-11.77,3.72-12.92,20.94S22.28,307.71,23,328-1.15,441.55,0,470.51s8.73,164.64,24.6,192.41,61.49-2.78,61.49-2.78S141.88,384.06,49.46,229.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-5",
    d: "M167.5,144.52s1.44,25.08-.65,41c0,0,10,35.19,36.1,37.54s67.93-47.48,67.93-47.48l-.94-20.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-jerry-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-5",
    d: "M164.3,83.11s-1.9-43.81,14.56-61.59c12.88-13.92,42.35-25.58,68-19.79,31.09,7,61.46,35,50.36,80.67,0,0-4,10.53-4,20.07s-1.37,29.66-5.36,43.13-11.82,32.89-20.46,40.63-18.72,16.57-22.14,21.61-14.59,9.36-25.39,7.92a42.87,42.87,0,0,1-29.17-18c-7.56-10.63-9.54-17.47-15.84-24.85s-12.07-23.41-12.43-32c-.27-6.5-3.42-26.11-.54-37.09C163.57,97.54,164.3,83.11,164.3,83.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-2",
    d: "M284.21,98s10.24-3.49,10,3.32-4.53,11.8-4.92,15.37c-.71,6.43-1.8,21.21-9.76,17.2S284.21,98,284.21,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-2",
    d: "M166.84,76.25s-6.77-6-10.21-4.67-4.07,8.24-4.19,13.79-2.1,12.57-2.18,15.9,5.9,20.36,13.57,17.84S166.84,76.25,166.84,76.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-2",
    d: "M166.77,74.94s-.85-40.37,14.66-56.41C193.58,6,221-4.15,244.47,1.7,273,8.8,300.35,35.14,289.19,77c0,0-3.88,9.62-4.08,18.41s-1.87,27.27-5.81,39.6-11.55,30-19.67,37-17.13,15.22-20.83,19.44-13.62,8.32-23.53,6.77A39.42,39.42,0,0,1,188.78,181c-6.75-9.93-8.43-16.27-14.08-23.2s-10.63-21.8-10.79-29.76c-.12-6-2.62-24.11.26-34.16C165.8,88.22,166.77,74.94,166.77,74.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-jerry-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-8",
    d: "M184.84,181.42S196,178,206.06,183.74a28.81,28.81,0,0,0,20.51,2.77s12.08-2.74,15.82,5.67S202.78,217,184.84,181.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-9",
    d: "M199.29,146s43.46,5.56,45.26,6.35-17.82,14.46-22.12,11.89S199.29,146,199.29,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-10",
    d: "M238.19,162.61c-.68,4.65-8.64,11.06-18.33,9.29S202.64,154,202.64,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-8",
    d: "M198.39,145.88c-2.65,0-10.11-2.24-1.55-7.79,4.56-3,18.93-3.84,24.34-2.21a30.24,30.24,0,0,0,8.8,1.21,10.65,10.65,0,0,1,3.36.5c4.5,1.41,14.37,3.58,17.42,10.57,1.11,2.56-.57,4.77-3.13,4.36a20.68,20.68,0,0,1-6.86-2.79l-16.7-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-11",
    d: "M208.77,144.93c-.16,1.67,1,5.43,13.24,7.37,6.48,1,14.36,1.12,14.23-1S208.93,143.25,208.77,144.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-12",
    d: "M247.63,152.52c-13.35-9.18-16.14-8-17.55-7.91a16.61,16.61,0,0,1-9.32-1.75c-5.62-2.84-24.68,2.54-24.68,2.54s26.26,6.21,31.55,6.56C234.26,152.4,247.63,152.52,247.63,152.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-13",
    d: "M196.21,145.45a19,19,0,0,1,6.47,2c2.67,1.74,7.51,4.52,8.57,5.4,1.62,1.34,10,4.75,15.71,4s15.64-4.6,17.59-4.56a30.42,30.42,0,0,1,3.08.19s-7.25,9.71-10,12.12c-3.19,2.76-9.87,4.42-17.59,3.1s-13.54-8.37-15.41-10.52S196.21,145.45,196.21,145.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-14",
    d: "M213.28,216.56s-9.87-1.55-14-1l-15.73,13s3,13.27,5.29,16.06l-1.68,5.77a74.67,74.67,0,0,0-2.58,13.24L169.24,387.06,220,399.33s-.63-133.92-3-151.64c0,0,14.08-11.59,14.08-15.24S213.28,216.56,213.28,216.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-15",
    d: "M283.08,340.39s-.55-10.47,4.76-13.05l55.75,7.75.41,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-15",
    d: "M281.17,340.67s46.1-4.08,73.3-1.36V357.8l-72.07,1.77S278.86,349.23,281.17,340.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-16",
    d: "M151.64,186.88s-9.82,6-18.56,7.7-81.91,31.08-83.62,35.19c0,0-10.55,61.79,6.31,103.22S77.44,420.66,81.3,455.82s4.37,127.91,7.35,146.88-9.09,72.94-9.09,72.94,208.2,25.65,283.63-7.54c0,0,1.88-64.64-8.27-86.74s-10.15-65.6-10.15-65.6L354.55,449s-.83-134.38,51.55-203c0,0-90.2-49.15-97.15-49s-94.66,220.14-94.66,220.14l-53.48-9.39S131.3,290.57,151.64,186.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-17",
    d: "M270.79,167.5s-8.25,19.38-58.46,49.14c0,0,22.65,23.69,30.37,34.48a2.38,2.38,0,0,0,3.81.07c7.61-9.74,33.8-44.36,35.23-61C281.74,190.2,276.29,171.94,270.79,167.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-18",
    d: "M163.63,175.67S143.57,195,128.8,203.52a16.61,16.61,0,0,0,8.21,7.32L122.38,221s-4.07,128,38.43,186.73l1.68-54.34S152.49,305.69,163.63,175.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-18",
    d: "M272.67,169.45s5.74,2.34,17.11,12.71A136.51,136.51,0,0,0,309,197l9.24,24.75-17.43,2.62,19.52,14.81s-70.69,159-91.61,167.85l-16.79-3.85,9.39-28.51S273,214.3,275.05,193.77C277,173.89,272.67,169.45,272.67,169.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-17",
    d: "M167.93,167.33s-.05,10.84-.28,13.6,9.18,19.66,33.9,34.7l-16.77,14.45-13.3,17.37a2.19,2.19,0,0,1-3.87-.8C164,231.93,154.36,184.28,167.93,167.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-19",
    d: "M206.33,393.59s28.46,8.14,34.25,22.06-37.85-8-37.85-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-20",
    d: "M158.56,438.33l-2.43-87.56a7.47,7.47,0,0,1,2.34-5.43c1.19-1.13,2.35-2.68,2.29-4.37,0,0,35.54,2.7,42.51-.56a12.58,12.58,0,0,0,2.54,3.84,10.69,10.69,0,0,1,3.29,7.47l2.45,90S170.92,448.5,158.56,438.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-jerry-21",
    cx: 181.88,
    cy: 339.02,
    rx: 22.01,
    ry: 7.14,
    transform: "translate(-1.23 0.67) rotate(-0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-4",
    d: "M406.1,246s5.22-4,13.79,56.81S465.53,435.47,453.53,471s-111.62-8.45-111.62-8.45S364.88,248.7,406.1,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-2",
    d: "M295.05,440.15,279,436.24s-28.64-14.61-42.59-25.53-73.87-12.59-81-9.71-6.22,13.2.3,14.72,30,2.12,35.49,3.48-24.72.61-32.31-.91-17.29-1.66-18.2,4.25,1.37,8.19,2.89,9.25c0,0-3.8,3.19-3.19,8s10.77,10.16,27.91,14.11c0,0-.31,3.94,6.37,8.49s32.91,15.62,32.91,15.62,10.24,8.89,22.83,9.94,39.87-2.27,43.37-.7,17.14,5.6,17.14,5.6S329.64,475.54,295.05,440.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-22",
    d: "M287,446.07a48.11,48.11,0,0,0-1.73-9.57,5,5,0,0,0-4.36-3.58,16.35,16.35,0,0,0-6.13.83c3.49,4,4.73,11.64,4.64,12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-22",
    d: "M278.64,475.73s-2.89,7.84-5.15,11.07a1.25,1.25,0,0,0,.6,1.88l6.16,2.28a1.26,1.26,0,0,0,1.54-.59c1.34-2.52,4.82-9.5,4.94-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-23",
    d: "M286.87,445.25l-6.87.05a1.71,1.71,0,0,0-1.69,1.84c.39,5.19,1.32,20.2-.47,27.9a1.72,1.72,0,0,0,1.71,2.12l6.88-.2a1.7,1.7,0,0,0,1.66-1.57c.38-4.86,1.46-20.17.5-28.63A1.71,1.71,0,0,0,286.87,445.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-3",
    d: "M303.74,463.75s-3.87,27.06-14.39,28.38c0,0-3.86-.86-5.35-1.34,0,0-2.72,7.78,9.16,8.76s22.56,7.7,22.56,7.7S307.44,470.57,303.74,463.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-jerry-4",
    d: "M294.68,439.61s24.9,1.33,34,7,11.1.6,18.17.6,12.72,5.05,25,0,37.56-5.25,54.93.61,28.06,2.62,29.48,10.3,5.45,26.45,1.21,33.12-17.77,39.57-43.62,37.15S304.43,534,304.43,534a60.63,60.63,0,0,1-1.81-24.24C304.43,496.88,309,454.63,294.68,439.61Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-jerry-24 eyeball",
    cx: 201.55,
    cy: 85.75,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-jerry-25 pupil",
    cx: 201.55,
    cy: 85.75,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-jerry-24 eyeball",
    cx: 255.33,
    cy: 93.13,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-jerry-25 pupil",
    cx: 255.33,
    cy: 93.13,
    r: 7.48
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerry);
export default __webpack_public_path__ + "static/media/Jerry.f7b6426d4f7b27ebae289808351bbb5e.svg";
export { ForwardRef as ReactComponent };